import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import "../products/productDetail.css";

const TableCustomerData = ({ data, index, currentPage, type = "" }) => {
  const navigate = useNavigate();
  return (
    <>
      {type === "pharmacy" ? (
        <tr className="table-rows1">
          <td className="table-each-row-data">
            {(currentPage - 1) * 10 + (index + 1)}
          </td>
          <td className="table-each-row-data">{data?.code ?? "--"}</td>
          <td className="table-each-row-data">
            {data?.pharmacy_name ? data?.pharmacy_name.toUpperCase() : "--"}
          </td>
          <td className="table-each-row-data">{data?.mobile ?? "--"}</td>
          <td className="table-each-row-data">
            {data?.pharmacySubscribedVendors?.length > 0
              ? data?.pharmacySubscribedVendors[0]?.onboarding_type === "attach"
                ? "Attach"
                : "Independent"
              : "--"}
          </td>
          {data?.status ? (
            <td className="table-each-row-data color-green">
              <span className="fw_600">Active</span>
            </td>
          ) : (
            <td className="table-each-row-data color-danger">
              <span className="fw_600">Inactive</span>
            </td>
          )}
          <td className="table-each-row-data">
            {data?.city?.name ? data?.city?.name : "--"}
          </td>

          <td className="table-each-row-data">
            <div className="all-button">
              <button
                className="button-view"
                type="button"
                onClick={() =>
                  navigate(`/customers/onboarded-pharmacy/view/${data.id}`, {
                    state: {
                      user_type: data?.customer_type,
                      pharmacy_id: data?.customer_type !== "doctor" && data?.id,
                      doctor_id: data?.customer_type == "doctor" && data?.id,
                    },
                  })
                }
              >
                {"view"}
              </button>
            </div>
          </td>
        </tr>
      ) : type === "doctor" ? (
        <tr className="table-rows1">
          <td className="table-each-row-data">
            {(currentPage - 1) * 10 + (index + 1)}
          </td>
          <td className="table-each-row-data">{data?.code ?? "--"}</td>
          <td className="table-each-row-data">
            {data?.customer_type == "doctor"
              ? `DR. ${data?.name.toUpperCase()}`
              : "--"}
          </td>
          <td className="table-each-row-data">{data?.mobile ?? "--"}</td>
          <td className="table-each-row-data">
            {data?.doctorSubscribedVendors?.length > 0
              ? data?.doctorSubscribedVendors[0]?.onboarding_type === "attach"
                ? "Attach"
                : "Dispensing"
              : "--"}{" "}
          </td>
          {data?.status ? (
            <td className="table-each-row-data color-green">
              <span className="fw_600">Active</span>
            </td>
          ) : (
            <td className="table-each-row-data color-danger">
              <span className="fw_600">Inactive</span>
            </td>
          )}
          <td className="table-each-row-data">
            {data?.city?.name ? data?.city?.name : "--"}
          </td>
          <td className="table-each-row-data">
            <div className="all-button">
              <button
                className="button-view"
                type="button"
                onClick={() =>
                  navigate(`/customers/onboarded-doctors/view/${data.id}`, {
                    state: {
                      user_type: data?.customer_type,
                      pharmacy_id: data?.customer_type !== "doctor" && data?.id,
                      doctor_id: data?.customer_type == "doctor" && data?.id,
                    },
                  })
                }
              >
                {"view"}
              </button>
            </div>
          </td>
        </tr>
      ) : (
        ""
      )}
    </>
  );
};

export default TableCustomerData;
